const CHAVES_MENSAGEM = [
    'mensagem', 'message', 'error', 'erro', 'motivo', 'descricao', 'description',
    'detalhe', 'detail', 'details', 'cause', 'causes', 'errors', 'validationErrors',
    'retorno', 'reason', 'msg', 'title', 'erros', 'body'
];

const CHAVES_IGNORADAS = [
    'payload', 'payload_tentado', 'xml', 'request', 'trace', 'file', 'line',
    'status', 'success', 'sucessos', 'id', 'id_aux'
];

const temConteudo = (valor) => {
    if (valor === null || valor === undefined) return false;
    if (typeof valor !== 'object') return String(valor).trim().length > 0;
    return Object.values(valor).some(temConteudo);
};

const LIMITE = 800;

const ehLixo = (texto) => !texto || texto === '[object Object]' || texto === 'null' || texto === 'undefined';

export const textoDeErro = (valor, profundidade = 0) => {
    if (valor === null || valor === undefined) return '';
    if (typeof valor === 'string') return ehLixo(valor.trim()) ? '' : valor.trim();
    if (typeof valor === 'number' || typeof valor === 'boolean') return String(valor);
    if (valor instanceof Error) return valor.message || '';
    if (profundidade > 5) return '';
    if (typeof valor !== 'object') return '';

    const partes = [];

    if (Array.isArray(valor)) {
        valor.forEach((item) => {
            const texto = textoDeErro(item, profundidade + 1);
            if (texto) partes.push(texto);
        });
    } else {
        CHAVES_MENSAGEM.forEach((chave) => {
            const texto = textoDeErro(valor[chave], profundidade + 1);
            if (texto) partes.push(texto);
        });
    }

    const unicas = [...new Set(partes)].filter(
        (parte, i, lista) => !lista.some((outra, j) => j !== i && outra.includes(parte))
    );
    if (unicas.length > 0) return unicas.join(' | ');

    if (Array.isArray(valor)) return '';

    const httpCode = valor.http_code ?? valor.httpCode ?? valor.status_code ?? valor.statusCode;
    if (httpCode !== undefined && httpCode !== null && httpCode !== '') {
        return Number(httpCode) === 0 ? 'Sem resposta da API (falha de conexão)' : `HTTP ${httpCode}`;
    }

    try {
        const json = JSON.stringify(valor, (chave, item) => (CHAVES_IGNORADAS.includes(chave) ? undefined : item));
        if (json && temConteudo(JSON.parse(json))) return json;
    } catch (e) {
        return '';
    }
    return '';
};

export const mensagemDeErro = (valor, padrao = 'Erro desconhecido.') => {
    const texto = textoDeErro(valor);
    if (!texto) return padrao;
    return texto.length > LIMITE ? `${texto.slice(0, LIMITE)}...` : texto;
};

export const listaDeErros = (valor) => {
    if (!valor) return [];
    const lista = Array.isArray(valor) ? valor : [valor];
    return lista.map((item) => textoDeErro(item)).filter(Boolean);
};
